/* eslint max-len: 0 */
export const messages = {
  usernameTitle: {
    label: {
      id: 'resetPassword.Form.UserNameTitle.Label',
      defaultMessage: 'Username',
    },
  },
  pageTitle: {
    label: {
      id: 'resetPassword.Form.PageTitle.Label',
      defaultMessage: 'Reset Your Password',
    },
  },
  required: {
    error: {
      id: 'resetPassword.Form.UserName.Required',
      defaultMessage: 'Required',
    },
  },
  intro: {
    label: {
      id: 'resetPassword.Form.Intro.Label',
      defaultMessage: 'Enter your username and we\'ll email you a temporary password.',
    },
  },
  resetPassword: {
    label: {
      id: 'resetPassword.Form.ResetPassword.Label',
      defaultMessage: 'Reset your password',
    },
  },
};
